import type { RefObject } from "react";

import { Button } from "@krea/shared/design-system/Button";
import {
  ResponsiveDialog,
  ResponsiveDialogContent,
} from "@krea/shared/design-system/modal/base-modal";

export interface IAdvisoryBookingModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  calendarUrl: string;
  title: string;
  container?: HTMLElement | null;
  returnFocusTo?: RefObject<HTMLElement | null>;
  closeLabel: string;
}

export const AdvisoryBookingModal = ({
  open,
  onOpenChange,
  calendarUrl,
  title,
  container,
  returnFocusTo,
  closeLabel,
}: IAdvisoryBookingModalProps) => (
  <ResponsiveDialog open={open} onOpenChange={onOpenChange}>
    <ResponsiveDialogContent
      onCloseAutoFocus={(event) => {
        if (!returnFocusTo?.current) return;
        event.preventDefault();
        returnFocusTo.current.focus();
      }}
      container={container}
      side="bottom"
      elevatedStacking
      /* An unprefixed utility LOSES to a prefixed one, and the variant already
         sets `lg:grid`, `lg:h-fit`, `lg:max-w-2xl` and `max-lg:pr-14` — four
         sizing bugs here had that one cause. */
      className="grid w-full grid-rows-[auto_minmax(0,1fr)_auto] overflow-hidden p-0 max-lg:h-[88svh] max-lg:pr-0 sm:rounded-2xl lg:h-[min(900px,88vh)] lg:max-w-[min(1200px,94vw)]"
    >
      <h5 className="m-0 px-4 pb-2 pt-4 text-center">{title}</h5>
      {/* A plain iframe, not `@calcom/embed-react`: `/embed` needs that
          library's postMessage handshake or it never paints. */}
      {open && (
        <iframe
          src={calendarUrl}
          title={title}
          className="h-full w-full border-0"
        />
      )}

      <div className="flex justify-end px-4 pb-4 pt-3">
        <Button
          variant="secondary"
          onClick={() => onOpenChange(false)}
          className="max-sm:w-full"
        >
          {closeLabel}
        </Button>
      </div>
    </ResponsiveDialogContent>
  </ResponsiveDialog>
);
